<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>尝试演示，看看Trinka的实际应用。</h1>
                        <span>借助此免费且功能强大的语法检查工具，可立即修订您的英语写作。Trinka让您的写作变得轻松自如。</span>
                        <!-- <a href="https://demo.trinka.ai/" target="_blank">现在就试试</a> -->
                        <a href="https://cloud.trinka.ai/signup?utm_source=try-a-demo&utm_medium=cn&utm_campaign=signup" target="_blank">现在就试试</a> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>适用于学术和技术写作的最佳语法和语言校正AI工具</h2>
                    <p>Trinka是最好的英语语法检查工具，可以立即增强和检查您的写作。 它的高级检查功能可突出显示错误并提供上下文建议，从而使您的写作焕然一新。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>发现其它工具不能发现的复杂错误</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka的功能远远超越了简单的语法检查，它还能发现学术写作、科学语气和风格所特有的难以检查的错误。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>技术用词选择</h4>
                            <p>Yield strength values, defined from <span class="wrong_text"> cycling</span> <span
                                    class="right_text"> cyclic</span> aging tests, are used for the parameterization of
                                the model.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>专为学术和技术写作而设计</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka专为帮助学者和技术作者而构建，可纠正3000多种复杂的语法错误和蹩脚的句子结构。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>句法</h4>
                            <p>The virus <span class="wrong_text"> is not requiring</span> <span class="right_text">
                                    does not require</span> us to <span class="wrong_text">remain</span> <span
                                    class="right_text"> stay</span> away from our communities.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>建议与您的主题有关的更改</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>一个由Al驱动的语法检查工具，已从数百万篇最佳的研究论文和文章中学习，为您提供最佳建议。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>高级拼写</h4>
                            <p>Grind tissue in <span class="wrong_text">Trizol reagent</span> <span class="right_text">
                                    TRIzol® Reagent</span> using a disposable <span class="wrong_text">pestel</span>
                                <span class="right_text"> pestle</span> and centrifuge for 10 min at 4°C.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>超越标准语法的校正</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka吸收了经验丰富的编辑和语言学家的专业知识。结果显而易见——它是最好的语言增强工具。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>敏感语言</h4>
                            <p>Eighty-eight percent were male and <span class="wrong_text">committed</span> <span
                                    class="right_text"> died by</span> suicide at a mean age of 25.6 years.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>准备提高您的写作技巧？</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" id="grammerSignUpButton">
                        <i class="fa fa-sign-in"></i>
                        <span>免费注册</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>使用感言</h2>
                    <p>查看用户对Trinka的评价</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>我一下就爱上<span class="OpenSansFonts">Trinka</span>了。祝贺你们开发出这个可以广泛协助编辑的程序，尤其是符合重要的文法惯例和具备精简字数功能的工具。</p>
                    <div class="testimonals_footer">
                        <p><strong>学术编辑,美国</strong></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>这是一个超越Grammarly的语法检查工具！我用<span class="OpenSansFonts">Trinka</span>重新检查了用<span class="OpenSansFonts">Grammarly</span>检查过一些文档。看到来自印度的如此优越产品，我感到非常惊喜！</p>
                    <div class="testimonals_footer">
                        <p><strong>放射科医师，印度</strong></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>我测试了Trinka，对其出色的功能印象深刻。它比我使用的语法检查器要好，我已经告诉研究实验室的同事使用Trinka。希望它在学术界得到广泛的应用。</p>
                    <div class="testimonals_footer">
                        <p>英国博士学者</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>